import { useQuery } from "@tanstack/react-query";
import { Link, useSearchParams } from "react-router-dom";
import ProgressLearning from "./components/learning/pages/progressLearning";
import { useSidebar } from "./context/sidebarContext";
import Sidebar from "./Sidebar";
import styles from "./styles/Dashboard.module.css";
import { baseAxios } from "./apis";
import Layout from "./components/ui/Layout";

// 1. We enhance our existing hook to calculate all the values this page needs.
const useCourseProgressQuery = (categoryId) => {
  return useQuery({
    queryKey: ["courseProgress", categoryId],
    queryFn: () => {
      const params = categoryId ? { category: categoryId } : {};
      return baseAxios
        .get("/api/courses/progress", { params })
        .then((res) => res.data);
    },
    // queryFn: () =>
    //   baseAxios.get("/api/courses/progress").then((res) => res.data),
    // The select option will transform the raw API data into the exact shape our component needs.
    select: (data = []) => {
      let totalProgress = 0;
      let totalModulesLeft = 0;
      let countOngoing = 0;
      const ongoingContents = [];
      let finishedCount = 0;
      let ongoingCount = 0;

      data.forEach((entry) => {
        const { course, progress_percentage = 0, completed } = entry;

        if (completed) {
          finishedCount++;
        } else {
          ongoingCount++;
        }

        const lessons = course.lessons || [];
        const exams = course.exams || [];
        const modules = [...lessons, ...exams];
        const remainingModules = Math.ceil(
          modules.length * (1 - progress_percentage / 100)
        );

        totalModulesLeft += remainingModules;
        totalProgress += progress_percentage;
        countOngoing++;

        const mappedLessons = lessons.map((lesson) => ({
          ...lesson,
          contentType: "lesson",
          user_enrolled: course.user_enrolled,
          course_id: course.id,
          progress: { completed },
        }));
        const mappedExams = exams.map((exam) => ({
          ...exam,
          contentType: "exam",
          user_enrolled: course.user_enrolled,
          course_id: course.id,
          progress: { completed },
        }));
        ongoingContents.push(...mappedLessons, ...mappedExams);
      });

      const progressPercent =
        countOngoing > 0 ? totalProgress / countOngoing : 0;

      return {
        ongoingContents,
        finishedCourses: finishedCount,
        ongoingCourses: ongoingCount,
        progressPercent,
        modulesLeft: totalModulesLeft,
      };
    },
  });
};

export const LearnProgress = () => {
  const [searchParams] = useSearchParams();
  const categoryId = searchParams.get("category");

  const { isOpen, toggleSidebar } = useSidebar();

  // 2. Call the single hook to get all data and the loading state.
  const { data, isLoading: loading } = useCourseProgressQuery(categoryId);

  // 3. All the manual useState and useEffect logic is now gone.
  // We just use the values from our hook, with fallbacks for the initial render.
  const {
    ongoingContents = [],
    finishedCourses = 0,
    ongoingCourses = 0,
    progressPercent = 0,
    modulesLeft = 0,
  } = data || {};

  return (
    <Layout>
      <div className="mt-7 mb-[-.5rem]">
        <p className="text-sm text-[#585F72] font-semibold">
          <Link to="/learn" className="text-[#0E0F11] hover:underline">
            Trading Track
          </Link>{" "}
          / <span className="text-[#0E0F11]/60">Progress Learning</span>
        </p>
      </div>
      <ProgressLearning
        finishedCourses={finishedCourses}
        ongoingCourses={ongoingCourses}
        progressPercent={progressPercent}
        modulesLeft={modulesLeft}
        allCourses={ongoingContents}
        loading={loading}
      />
    </Layout>
  );
};
